// 1、导入axios以及拦截器
import service from './request'

//数据查询
export const list = (data) => {
    return service({
        url: '/api/vehicle/warning/plate',
        method: 'post',
        data
    })
};
//利用code换取openid
export const wxcode = (data) => {
    return service({
        url: '/api/wx/oauth2/callback?code=' + data,
        method: 'get'
    })
};
//核实方法
export const verify = (data) => {
    return service({
        url: `/api/vehicle/warning/verify`,
        method: 'post',
        data
    })
}
//查询历史记录
export const history = (data) => {
    return service({
        url: `/api/vehicle/warning/query-records?openId=${data}`,
        method: 'get',
    })
}
//删除历史记录
export const deleteHistory = (data) => {
    return service({
        url: `/api/vehicle/warning/query-records?openId=${data}`,
        method: 'delete',
    })
}
//新增白名单
export const addWhite = (data, openid) => {
    return service({
        url: `/api/vehicle/whitelist/add?openId=${openid}`,
        method: 'post',
        data
    })
}
//新增长期白名单
export const addLongWhite = (data, openid) => {
    return service({
        url: `/api/vehicle/whitelist/addLong?openId=${openid}`,
        method: 'post',
        data
    })
}
//查询白名单
export const whiteList = (data) => {
    return service({
        url: `/api/vehicle/whitelist/list`,
        method: 'post',
        data
    })
}
//查询长期白名单
export const whiteListLong = (data) => {
    return service({
        url: `/api/vehicle/whitelist/listLong`,
        method: 'post',
        data
    })
}
//删除白名单
export const deletewhiteList = (data, open) => {
    return service({
        url: `/api/vehicle/whitelist/delete/${data}?openId=${open}`,
        method: 'delete',
    })
}
//删除长期白名单
export const deleteLongwhiteList = (data, open) => {
    return service({
        url: `/api/vehicle/whitelist/deleteLong/${data}?openId=${open}`,
        method: 'delete',
    })
}
//查询模型数据
export const DataRole = (data, token) => {
    return service({
        url: `/bapi/screen/getScreenDataRole?access_token=${token}&appkey=97c552120197c55212de0000`,
        method: 'post',
        data
    })
}
//获取token
export const getToken = (data) => {
    return service({
        url: `/api/wx/oauth2/getToken?openId=${data}`,
        method: 'get'
    })
}
//携带主键id查询
export const getById = (data) => {
    return service({
        url: `/api/vehicle/warning/getById?id=${data.id}&openId=${data.openid}`,
        method: 'get'
    })
}
//查询预警信息
export const getvehicle = (data) => {
    return service({
        url: `/api/vehicle/warning/page-list`,
        method: 'post',
        data
    })
}
//查询历史记录
export const getHistory = (data) => {
    return service({
        url: `/api/vehicle/warning/before-entry-time?openId=${data.openid}&plateNumber=${data.plateNumber}&entryTime=${data.entryTime}`,
        method: 'get',
    })
}

//登录(新)
export const BySM2 = (data) => {
    return service({
        url: '/bapi/user/getPublicKeyBySM2?token=false',
        method: 'get',
    })
}
export const Login = (nuserNme, passsword, redisKey) => {
    return service({
        url: `/bapi/login?grant_type=password&auth_type=org&username=` + encodeURIComponent(nuserNme) + '&password=' + encodeURIComponent(passsword) + '&redisKey=' + redisKey,
        method: 'post',
    })
}
//判断是否有添加长期白名单权限
export const isAddLongWhite = (data) => {
    return service({
        url: `/api/wx/oauth2/user/${data}`,
        method: 'get',
    })
}

